module.exports = __webpack_public_path__ + "img/ecsocenter.550c246a.png";